import Container from "./Container.js"
import Slider from "./Slider.js"
import Utils from "./Utils.js"

export default class Progress extends Slider {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-progress", true)
    this.state.altText = "MSG_SEEK"
    this.state.textVisible = "visible"
    this.bindHandlers(["onMouseMove", "onaddurationchange", "onadtimeupdate", "onaddurationchange", "onadmanagerloaded"])
    this.isTouch = akamai.amp.Utils.isTouch
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get propsList() {
    const props = super.propsList
    props.onMouseMove = this.onMouseMove
    return props
  }

  get markers() {
    return this.refs.markers
  }

  format(value) {
    return Utils.formatTimecode(value, this.max)
  }

  onready() {
    this.player.addEventListener("adbreakend", this.ondurationchange)
    this.player.addEventListener("adtimeupdate", this.onadtimeupdate)
    this.player.addEventListener("addurationchange", this.onaddurationchange)
  }

  onmediachange() {
    this.update({value: 0})
    this.range = 0
  }

  ontimeupdate() {
    if (this.dragging)
      return
    this.update({value: this.player.currentTime})
  }

  onseeking() {
    this.update({value: this.player.currentTime})
  }

  onprogress(event) {
    this.range = event.detail
  }

  oncueschange(event) {
    const cues = event.detail
    const markers = this.markers

    markers.clear()

    if (cues == null || cues.length <= 0)
      return

    const duration = this.player.duration
    cues.forEach((cue, index) => {
      if (cue.startTime <= 0)
        return
      markers.addComponent(<div className="amp-marker" style={{left: `${cue.startTime / duration * 100}%`}} key={index} />)
    })
  }

  ondurationchange(event) {
    this.increment = 10 / this.player.duration
    this.max = this.player.duration
    this.update({value: ((event.type == "breakend" && event.data.type == "preroll") ? 0 : this.player.currentTime)})
  }

  onadtimeupdate(event) {
  	if(this.player.playState == "ready")
  		return
    this.update({value: event.detail})
  }

  onaddurationchange(event) {
    this.max = event.detail.duration
  }

  onMouseMove(event) {
    const offset = this.refs.element.getBoundingClientRect()
    const pos = Utils.getEventPos(event)
    const percent = (pos.x - offset.left) / offset.width
    this.setState({textPercent: akamai.amp.Utils.clamp(Utils.round(percent, 4), 0, 1)})
  }

  onKeyPress(event) {
    if ((this.player.ads && this.player.ads.inProgress) || this.player.playState == "ready") {
      return
    }
    super.onKeyPress(event)
  }

  onHandleMouseDown(event) {
    super.onHandleMouseDown(event)
    if (this.isTouch)
      this.setState({textVisible: "visible"})
  }

  onHandleMouseMove(event) {
    super.onHandleMouseMove(event)
    this.onMouseMove(event)
  }

  onHandleMouseUp(event) {
    super.onHandleMouseUp(event)
    if (this.isTouch)
      this.setState({textVisible: "hidden"})
  }

  onChange(states) {
    if (this.dragging)
      return
    this.player.currentTime = states.value
  }

  get children() {
    const textPercent = `${this.state.textPercent * 100}%`
    const minClampValue = this.refs.element ? ((this.refs.text.clientWidth/1.3)*100/this.refs.element.clientWidth) : 0
    const maxClampValue = 100 - minClampValue
    const textValue = `${akamai.amp.Utils.clamp(Utils.round(this.state.textPercent * 100, 2), minClampValue, maxClampValue)}%`

    return (
      <div>
        <Container ref="markers" className="amp-markers"></Container>
        <div ref="text" className="amp-text" style={{left: textValue, visibility: this.state.textVisible}}>{this.format(this.state.textPercent * this.player.duration)}</div>
      </div>
    )
  }
}
